<script>
import { BIcon } from 'bootstrap-vue'
import { appConfig } from '@src/app.config'
import { services } from '../../utils/common-services'

export default {
  components: {
    BIcon,
  },
  page: {
    title: 'Form',
    meta: [{ name: 'description', content: `Application ${appConfig.title}` }],
  },
  data() {
    return {
      classToggle: false,
      profile: null,
      menuToggle: false,
      minimizeFooter: false,
      windowWidths: window.screen.width,
      appRightToggle: false,
      applicationListToggle: false,
    }
  },
  watch: {
    classToggle(oldVal, newVal) {
      if (newVal !== oldVal) {
        //    console.log(this.menuToggle)
        //  this.setMenubar({ newVal: true })
        this.$root.$emit('changeMenu', {
          data: true,
        })
        this.$root.$emit('open', this.classToggle)
      }
    },
    menuToggle(oldVal, newVal) {
      // console.log(this.classToggle)
      if (oldVal !== newVal) {
        this.scrollToTop()
        this.applicationListToggle = this.menuToggle
        //  console.log(this.classToggle)
      }
    },
  },
  beforeMount() {
    /* if()
     var check = this.$store.getters['jv/get']('menu_list')
    var id = Object.keys(check)

    this.actions = services.searchActions(
      'Applicants',
      check[id]._jv.attrs.config
    )

    if (this.actions !== undefined) {
      if (this.actions.indexOf('create') !== -1) this.createApplicantMenu = true
      if (this.actions.indexOf('edit') !== -1) this.editApplicantfMenu = true
      if (this.actions.indexOf('delete') !== -1) this.deleteApplicantMenu = true
    } else this.$router.push({ name: '404' }) */
    this.getUser()
  },
  beforeDestroy() {
    this.$off('clickChange')

    this.$root.$off('callAutoSave')
    var doc = this.$refs.formTop
    if (doc !== undefined) doc.innerHTML = ''
  },
  methods: {
    getUser() {
      this.profile = services.decodeJWT(services.getAuth())
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    },
    //   this.$emit('menu',{data:false})
    //         console.log('changes'+ false)
  },
}

// Dashed input field
// function addHyphen (element) {
//   let ele = document.getElementById(element.id);
//     ele = ele.value.split('-').join('');    // Remove dash (-) if mistakenly entered.

//     let finalVal = ele.match(/.{1,3}/g).join('-');
//     document.getElementById(element.id).value = finalVal;
// }
</script>
<template>
  <div ref="formTop">
    <!-- Right side -->

    <StaffBaseMultipleUser
      :toggle="applicationListToggle"
      @clickChange="menuToggle = $event"
    />
    <!-- Right side -->

    <footer id="footer" :class="$style.footerWraper">
      <div
        :class="
          minimizeFooter
            ? [$style.responsiveFooter, $style.mimimize]
            : [$style.responsiveFooter]
        "
      >
        <div class="position-relative">
          <a
            :class="$style.footerMinimize"
            class="position-absolute"
            @click="minimizeFooter = !minimizeFooter"
            ><BIcon icon="grip-vertical"></BIcon
          ></a>
          <b-container fluid>
            <b-row>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.menu]"
                  @click="classToggle = !classToggle"
                  ><BIcon class="" icon="grid"></BIcon>
                  <span :class="$style.footerMenuTxt">Menu</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="[$style.footerMenu, $style.dashboard]"
                  @click="$router.push({ name: 'dashboard' })"
                >
                  <BIcon icon="grid1x2"></BIcon>
                  <span :class="$style.footerMenuTxt">{{
                    profile.is_staff ? 'Dashboard' : 'Welcome'
                  }}</span>
                </button>
              </b-col>
              <b-col cols="4" sm="4">
                <button
                  :class="
                    menuToggle
                      ? [$style.footerMenu, $style.settings, $style.selected]
                      : [$style.footerMenu, $style.settings]
                  "
                  @click="menuToggle = !menuToggle"
                >
                  <BIcon class="" icon="folder"></BIcon>
                  <span :class="$style.footerMenuTxt">Check Progress</span>
                </button>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
      <div class="clear"></div>
    </footer>
    <!-- toaster -->
    <!-- <div :class="$style.toasterMainWrap">
      <b-button @click="$bvToast.show('resetPassword')">Show toast</b-button>
      <b-toast id="resetPassword" solid no-auto-hide b-toaster-top-right>
        <div
          class="d-flex"
          :class="[$style.loginToasterWraper, $style.success]"
        >
          <div :class="$style.toasterLeft">
            <span :class="$style.toasterIcon"></span>
          </div>
          <div :class="$style.toasterRight">
            <strong class="mr-auto" :class="$style.toasterHeader"
              >Notice!</strong
            >

            <ul class="mb0">
              <li
                >There are many variations of passages of Lorem Ipsum
                available.</li
              >
            </ul>
          </div>
          <div class="clear"></div>
        </div>
      </b-toast>
    </div> -->
    <!-- toaster -->
  </div>
</template>

<style lang="scss" module>
@import '@design';

::placeholder {
  color: #c3c8cc;
}

.form {
  padding: 20px 30px;
}

@media (max-width: 767px) {
  .responsiveFooter {
    display: block;
  }
}
</style>
